import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import AuthCallback from "@/pages/AuthCallback";
import CityLanding from "@/pages/CityLanding";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import MapPage from "@/pages/MapPage";
import RoomDetail from "@/pages/RoomDetail";
import CoachesPage from "@/pages/CoachesPage";
import HowItWorks from "@/pages/HowItWorks";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import PaymentResult from "@/pages/PaymentResult";
import CoachProfile from "@/pages/CoachProfile";
import AdminPage from "@/pages/AdminPage";
import RoomShowcase from "@/pages/RoomShowcase";
import ProSuccess from "@/pages/ProSuccess";
import ApplyPage from "@/pages/ApplyPage";
import LegalPage from "@/pages/LegalPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import { I18nProvider } from "@/lib/i18n";
import InstallPrompt from "@/components/InstallPrompt";

export default function App() {
  return (
    <div className="App">
      <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <InstallPrompt />
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
      </I18nProvider>
    </div>
  );
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/carte" element={<MapPage />} />
            <Route path="/salles/:id" element={<RoomDetail />} />
            <Route path="/coachs" element={<CoachesPage />} />
            <Route path="/coachs/:id" element={<CoachProfile />} />
            <Route path="/vitrine/:id" element={<RoomShowcase />} />
            <Route path="/postuler/:id" element={<ApplyPage />} />
            <Route path="/legal/:slug" element={<LegalPage />} />
            <Route path="/salles-de-sport/:city" element={<CityLanding />} />
            <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminPage /></ProtectedRoute>} />
            <Route path="/pro/succes" element={<ProtectedRoute roles={["coach"]}><ProSuccess /></ProtectedRoute>} />
            <Route path="/comment-ca-marche" element={<HowItWorks />} />
            <Route path="/connexion" element={<Login />} />
            <Route path="/inscription" element={<Register />} />
            <Route path="/tableau-de-bord" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/paiement/succes" element={<PaymentResult />} />
            <Route path="/paiement/annule" element={<PaymentResult cancelled />} />
          </Routes>
  );
}
